export default __webpack_public_path__ + "static/sustainhero-f281ccf45a4c42acde43383b63282002.jpg";